import { useMutation } from "@tanstack/react-query";
import { simulatePurchase } from "@/api/endpoints/orders";

export function useSimulatePurchase() {
  return useMutation({
    mutationFn: (checkoutId: string) => simulatePurchase(checkoutId),
  });
}
